import { useEffect, useRef, useState } from 'react'
import { NeoniApi } from '../lib/api'

function useRefinementRequest(api: NeoniApi, accountingPeriodId: string | undefined) {
	const [loadedContext, setLoadedContext] = useState<{ api: NeoniApi; accountingPeriodId: string | undefined }>()
	const controller = useRef<AbortController>()

	useEffect(() => () => controller.current?.abort(), [api, accountingPeriodId])

	const start = (request: (signal: AbortSignal) => void) => {
		controller.current?.abort()
		controller.current = new AbortController()
		setLoadedContext({ api, accountingPeriodId })
		request(controller.current.signal)
	}

	return {
		current: loadedContext?.api === api && loadedContext.accountingPeriodId === accountingPeriodId,
		start,
	}
}

export default useRefinementRequest
